// extracted by mini-css-extract-plugin
module.exports = {"container":"_13gvoT","wrapper":"_28DGzr","logo":"bns0xP","message":"_13xsSD","trademarks":"_2BT2AJ","info":"_1d8akG","mobile":"_2EIVfT"};